"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeightHelperStyle = void 0;

var _fonts = require("../fonts");

var _grid = require("../grid");

var fontWeightHelperStyle = function fontWeightHelperStyle(fontWeight) {
  return (0, _grid.map)(fontWeight, function (fw) {
    return "font-weight: ".concat(_fonts.FontWeightValue[fw], " !important;");
  });
};

exports.fontWeightHelperStyle = fontWeightHelperStyle;